export default {
  searchText(state) {
    return state.searchText;
  },
  listOptions(state) {
    return state.listOptions;
  },
  stringFilter(state) {
    if (state.searchText) {
      const searchText = state.searchText.toLowerCase();
      return `fornecedor like '%${searchText}%' or descricao like '%${searchText}%'`;
    }
    return '';
  },
};
